<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <HeaderPanel
        title="Setting"
        :hasDropdown="false"
        :hasSearch="false"
        routerPath="/setting-cover-sheet/detail/0"
      />

      <div class="bg-white border-red p-2 p-lg-3 mt-3">
        <b-table
          responsive
          striped
          hover
          :busy="isBusy"
          :items="items"
          :fields="fields"
          class="table-main table-custom"
          show-empty
          empty-text="No matching records found"
        >
          <template #cell(is_active)="{ item }">
            <div :class="item.is_active ? 'text-success' : 'text-error'">
              {{ item.is_active ? "Active" : "Inactive" }}
            </div>
          </template>

          <template #cell(action)="{ item }">
            <font-awesome-icon
              icon="pencil-alt"
              class="pointer text-warning"
              @click="$router.push(`/setting-cover-sheet/detail/${item.id}`)"
            />
          </template>
        </b-table>
        <Pagination
          @handleChangeTake="handleChangeTake"
          :filter="filter"
          :rows="rows"
          @pagination="pagination"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
// import SidebarFilter from "@/components/coupon/SidebarFilter";
import HeaderPanel from "@/components/HeaderPanel";
import Pagination from "@/components/Pagination";
export default {
  components: {
    OtherLoading,
    // SidebarFilter,
    HeaderPanel,
    Pagination,
  },
  data() {
    return {
      isLoading: false,
      isBusy: false,
      fields: [
        { label: "Name", key: "name" },
        { label: "Sort Order", key: "sort_order" },
        { label: "Status", key: "is_active" },
        { label: "Action", key: "action" },
      ],
      items: [],
      filter: {
        user_guid: this.$cookies.get("print_tag_admin_user_guid"),
        page: 1,
        take: 10,
        search: "",
      },
      rows: 0,
    };
  },
  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      this.isLoading = true;
      let payload = { ...this.filter, setting_type_id: 3 };

      this.isBusy = true;
      const res = await this.axios.post(`/setting/getlist`, payload);

      this.rows = res.data.detail.total_count;
      this.items = res.data.detail.detail.map((x, index) => ({
        ...x,
        index: index + 1 + this.filter.take * (this.filter.page - 1),
      }));
      this.isLoading = false;
      this.isBusy = false;
    },
    async handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      await this.getList();
    },
    pagination(page) {
      this.filter.page = page;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep thead {
  background-color: var(--theme-secondary-color);
  color: var(--font-color);
}
.alert-error {
  text-align: center;
  padding: 20px;
  color: #000;
}
::v-deep .custom-select {
  @media (max-width: 767px) {
    width: 100%;
  }
}
::v-deep .header-tablepage {
  font-weight: 600;
}
.btn-create {
  color: #fff;
  background-color: var(--primary-color);
  border: none;
  margin: 15px 0;
  padding: 5px 10px;
  font-size: 16px;
  border-radius: 5px;
}
::v-deep .input-group-text {
  background-color: #fff;
  padding: 0 0.75rem;
}
::v-deep .nav.nav-tabs {
  background-color: white;
}
::v-deep .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  background-color: transparent !important;
  color: var(--primary-color) !important;
  border-bottom: 4px solid var(--primary-color) !important;
}
::v-deep .nav-tabs {
  border: none;
}
::v-deep .nav-tabs .nav-link {
  border: none;
  border-right: 1px solid #cfcfcf;
}
::v-deep .nav-tabs .nav-link {
  border-color: #d8dbe0 !important;
  color: #717171 !important;
}
::v-deep .nameOfTheClass {
  max-width: 250px !important;
}
::v-deep .btn-filter button,
.btn-filter {
  color: var(--primary-color) !important;
  border-color: var(--primary-color);
  font-weight: 100;
}
::v-deep .width-td-img {
  width: 200px !important;
}
</style>
